<script>
import lazyLoadComponent from '@router/lazyload-component'

export default {
  components: {
    Year: () => lazyLoadComponent(import('./Year')),
    Light: () => lazyLoadComponent(import('./Light')),
    LightSetting: () => lazyLoadComponent(import('./LightSetting')),
  },
  props: {
    defaultValue: {
      type: Object,
      default: () => {},
    },
  },
  data() {
    return {
      activeGroupIndex: '',
      groups: [],
      activeInventoryId: '',
      activeLightId: '',
      activeLightTitle: '',
      showLight: false,
      showLightSetting: false,
      activelightSettingInfo: {},
      lightSettings: [],
      componentKey: 0,
      tryingStoreSetting: false,
    }
  },
  computed: {
    productId() {
      return this.defaultValue.id
    },
  },
  methods: {
    updateActiveYear(year) {
      this.activeInventoryId = year.id
      this.tryToFetchLightSetting()
    },
    updateActiveLight(light) {
      this.activeLightId = light.id
      this.activeLightTitle = light.title
      this.tryToFetchLightSetting()
    },
    async tryToFetchLightSetting() {
      if (this.activeInventoryId !== '' && this.activeLightId !== '') {
        const response = await this.$store.dispatch('product/fetchPrices', {
          productId: this.productId,
          query: {
            inventoryId: this.activeInventoryId,
            itemId: this.activeLightId,
          },
        })

        this.activelightSettingInfo = Object.assign({}, response[0])
        this.forceRerender()

        if (response.length) this.showNextStepButton()

        this.tryToFetchAllLightSetting()
      }
    },
    async tryToFetchAllLightSetting() {
      this.lightSettings = await this.$store.dispatch('product/fetchPrices', {
        productId: this.productId,
        query: {
          inventoryId: this.activeInventoryId,
        },
      })
      this.$refs.light && this.$refs.light.mergeList([...this.lightSettings])
    },
    async tryToStoreSetting(setting) {
      this.tryingStoreSetting = true
      await this.$store.dispatch('product/storePrices', { storeData: this.formatStoreSetting(this.mergeLightSettings(setting)), productId: this.productId, inventoryId: this.activeInventoryId })
      this.tryingStoreSetting = false
      this.$message({ message: '儲存成功！', type: 'success' })
      this.showNextStepButton()
      this.tryToFetchAllLightSetting()
      this.tryToFetchLightSetting()
    },
    forceRerender() {
      this.componentKey += 1
    },
    showNextStepButton() {
      this.$emit('validate', true)
    },
    mergeLightSettings(activeSetting) {
      if (activeSetting.id === undefined) {
        this.lightSettings.push(activeSetting)
        return [...this.lightSettings]
      }

      return this.lightSettings.map((setting) => {
        if (setting.id === activeSetting.id) return { ...activeSetting }
        return setting
      })
    },
    formatStoreSetting(settings) {
      return settings.map((data) => {
        if (data.saleStartDate !== '') {
          const saleStartDate = data.saleStartDate === null ? '' : /:\d{2}:\d{2}$/.test(data.saleStartDate) ? data.saleStartDate.replace(/:\d{2}$/g, '') : data.saleStartDate
          const saleEndDate = data.saleEndDate === null ? '' : /:\d{2}:\d{2}$/.test(data.saleEndDate) ? data.saleEndDate.replace(/:\d{2}$/g, '') : data.saleEndDate
          return {
            ...data,
            saleStartDate,
            saleEndDate,
          }
        }
        return data
      })
    },
    hideLightAndSetting() {
      this.showLight = false
      this.activeInventoryId = ''
      this.activeLightId = ''
    },
  },
}
</script>

<template>
  <div>
    <el-row>
      <el-col :span="8">
        <div :class="$style['step-title']">1 請選擇年份</div>
        <Year @update-year="updateActiveYear" @show-light="showLight = true" @hide="hideLightAndSetting"> </Year
      ></el-col>
      <transition :name="$style.list"
        ><el-col :span="8" v-if="showLight" :key="'light'"
          ><div :class="$style['step-title']">2 新增此年度燈種</div
          ><Light ref="light" @update-light="updateActiveLight" @show-light-setting="showLightSetting = true" @get-light-settings="tryToFetchAllLightSetting"> </Light></el-col
      ></transition>
      <transition :name="$style.list">
        <el-col :span="8" v-if="activeLightId" :key="'lightsetting'"
          ><div :class="$style['step-title']">3 燈種設定</div
          ><LightSetting
            v-loading="tryingStoreSetting"
            :key="componentKey"
            :inventory-id="activeInventoryId"
            :item-id="activeLightId"
            :default-value="activelightSettingInfo"
            :light-title="activeLightTitle"
            @save-setting="tryToStoreSetting"
          >
          </LightSetting
        ></el-col>
      </transition>
    </el-row>
  </div>
</template>

<style lang="scss" module>
.step-title {
  color: white;
  background-color: #bf7e45;
  text-align: center;
  padding: 15px 0;
}

.list {
  &:global(-enter-active),
  &:global(-move) {
    transition: 500ms cubic-bezier(0.59, 0.12, 0.34, 0.95);
    transition-property: opacity, transform;
  }
  &:global(-enter) {
    opacity: 0;
    transform: translateX(50px);
  }
  &:global(-enter-to) {
    opacity: 1;
    transform: translateX(0);
  }
}
</style>
